import {
  COMPANY_DETAIL_START,
  COMPANY_DETAIL_SUCCESS,
  COMPANY_DETAIL_FAIL,
  COMPANY_BRANCHES_START,
  COMPANY_BRANCHES_SUCCESS,
  COMPANY_BRANCHES_FAIL,
  DEPARTMENT_OF_BRANCH_START,
  DEPARTMENT_OF_BRANCH_SUCCESS,
  DEPARTMENT_OF_BRANCH_FAIL,
  UPDATE_BRANCH_START,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  CREATE_BRANCH_START,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAIL,
  CREATE_DEPARTMENT_START,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_START,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  UPDATE_COMPANY_START,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAIL,
  UPLOAD_COMPANY_LOGO_START,
  UPLOAD_COMPANY_LOGO_SUCCESS,
  UPLOAD_COMPANY_LOGO_FAIL,
  DELETE_BRANCH_START,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  DELETE_DEPARTMENT_START,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  CREATE_COMPANY_START,
  CREATE_COMPANY_SUCCESS,
  CREATE_COMPANY_FAIL
} from './constants';
import {
  requestGetCompany,
  requestGetCompanyBranches,
  requestGetDepartmentsOfBranch,
  requestUpdateBranch,
  requestCreateBranch,
  requestCreateDepartment,
  requestUpdateDepartment,
  requestUpdateCompany,
  requestUploadLogoCompany,
  requestDeleteBranch,
  requestDeleteDepartments,
  requestCreateCompany
} from '../../api/company';
import { action } from '../action';

export const companyDetailAction = action(COMPANY_DETAIL_START, COMPANY_DETAIL_SUCCESS, COMPANY_DETAIL_FAIL);
export const updateCompanyAction = action(UPDATE_COMPANY_START, UPDATE_COMPANY_SUCCESS, UPDATE_COMPANY_FAIL);
export const createCompanyActions = action(CREATE_COMPANY_START, CREATE_COMPANY_SUCCESS, CREATE_COMPANY_FAIL);
export const uploadCompanyLogoAction = action(UPLOAD_COMPANY_LOGO_START, UPLOAD_COMPANY_LOGO_SUCCESS, UPLOAD_COMPANY_LOGO_FAIL);
export const companyBranchesAction = action(COMPANY_BRANCHES_START, COMPANY_BRANCHES_SUCCESS, COMPANY_BRANCHES_FAIL);
export const updateBranchActions = action(UPDATE_BRANCH_START, UPDATE_BRANCH_SUCCESS, UPDATE_BRANCH_FAIL);
export const createBranchAction = action(CREATE_BRANCH_START, CREATE_BRANCH_SUCCESS, CREATE_BRANCH_FAIL);
export const deleteBranchAction = action(DELETE_BRANCH_START, DELETE_BRANCH_SUCCESS, DELETE_BRANCH_FAIL);
export const deleteDepartmentAction = action(DELETE_DEPARTMENT_START, DELETE_DEPARTMENT_SUCCESS, DELETE_DEPARTMENT_FAIL);
export const createDepartmentActions = action(CREATE_DEPARTMENT_START, CREATE_DEPARTMENT_SUCCESS, CREATE_DEPARTMENT_FAIL);
export const updateDepartmentActions = action(UPDATE_DEPARTMENT_START, UPDATE_DEPARTMENT_SUCCESS, UPDATE_DEPARTMENT_FAIL);
export const departmentsDetailActions = action(DEPARTMENT_OF_BRANCH_START, DEPARTMENT_OF_BRANCH_SUCCESS, DEPARTMENT_OF_BRANCH_FAIL);

export const getCompany = () => async (dispatch) => {
  try {
    dispatch(companyDetailAction.start());
    const data = await requestGetCompany();
    dispatch(companyDetailAction.success(data));
  } catch (error) {
    dispatch(companyDetailAction.fail(error.detail));
  }
};

export const getCompanyBranches = () => async (dispatch) => {
  try {
    dispatch(companyBranchesAction.start());

    const data = await requestGetCompanyBranches();

    const transformData = data.map(({ id, name, users, departments }) => ({
      id,
      label: name,
      users,
      departments: departments?.map(({ id, name }) => {
        return { id, label: name };
      })
    }));

    dispatch(companyBranchesAction.success(transformData));
  } catch (error) {
    dispatch(companyBranchesAction.fail(error.detail));
  }
};

export const deleteBranch = (id) => async (dispatch) => {
  try {
    dispatch(deleteBranchAction.start());
    await requestDeleteBranch(id);
    dispatch(deleteBranchAction.success(id));
  } catch (error) {
    dispatch(deleteBranchAction.fail({ detail: error.detail, id, date: new Date() }));
  }
};

export const getDepartmentsOfBranch = (branchId) => async (dispatch) => {
  try {
    dispatch(departmentsDetailActions.start());
    const data = await requestGetDepartmentsOfBranch(branchId);

    const transformData = data.map(({ id, name }) => ({
      id,
      label: name
    }));

    dispatch(departmentsDetailActions.success(transformData, branchId));
  } catch (error) {
    dispatch(departmentsDetailActions.fail(error.detail));
  }
};

export const updateBranch = (id, payload) => async (dispatch) => {
  try {
    dispatch(updateBranchActions.start());
    const data = await requestUpdateBranch(id, payload);
    dispatch(updateBranchActions.success(data));
  } catch (error) {
    dispatch(updateBranchActions.fail(error.detail));
  }
};

export const createBranch = (data) => async (dispatch) => {
  try {
    dispatch(createBranchAction.start());
    const res = await requestCreateBranch(data);
    const transformData = { id: res.data.id, label: res.data.name };
    dispatch(createBranchAction.success(transformData));
  } catch (error) {
    dispatch(createBranchAction.fail(error.detail));
  }
};

export const createDepartment = (data) => async (dispatch) => {
  try {
    dispatch(createDepartmentActions.start());
    const res = await requestCreateDepartment(data);
    const transformData = { id: res.data.id, label: res.data.name };
    dispatch(createDepartmentActions.success({ payload: transformData, id: data.branch_id }));
  } catch (error) {
    dispatch(createDepartmentActions.fail(error.detail));
  }
};

export const deleteDepartment = (branchId, departmentId) => async (dispatch) => {
  try {
    dispatch(deleteDepartmentAction.start());
    await requestDeleteDepartments(departmentId);
    dispatch(deleteDepartmentAction.success({ branchId, departmentId }));
  } catch (error) {
    dispatch(deleteDepartmentAction.fail(error.detail));
  }
};

export const updateDepartment = (id, payload) => async (dispatch) => {
  try {
    dispatch(updateDepartmentActions.start());
    const data = await requestUpdateDepartment(id, payload);
    dispatch(updateDepartmentActions.success(data));
  } catch (error) {
    dispatch(updateDepartmentActions.fail(error.detail));
  }
};

export const updateCompany = (companyData) => async (dispatch) => {
  try {
    dispatch(updateCompanyAction.start());
    const { data } = await requestUpdateCompany(companyData);
    dispatch(updateCompanyAction.success(data));
  } catch (error) {
    dispatch(updateCompanyAction.fail(error.detail));
  }
};

export const createCompany = (companyData) => async (dispatch) => {
  try {
    dispatch(createCompanyActions.start());
    const { data } = await requestCreateCompany(companyData);
    dispatch(createCompanyActions.success(data));
  } catch (error) {
    dispatch(createCompanyActions.fail(error.detail));
  }
};

export const uploadCompanyLogo = (id, logo) => async (dispatch) => {
  try {
    dispatch(uploadCompanyLogoAction.start());
    const data = await requestUploadLogoCompany(id, logo);
    dispatch(uploadCompanyLogoAction.success(data));
  } catch (error) {
    dispatch(uploadCompanyLogoAction.fail(error.detail));
  }
};
